import actions from './actions'
import apiV1 from 'lib/api/lmsApiV1'
import apiV2 from 'lib/api/lmsApiV2'

const fetchTrainingAttempts = (siteId, license, learners) => {
  return async (dispatch, getState) => {
    const state = getState()
    const program = license.product.programCodes[0]
    const key = `${siteId}.${license.id}.${program}`
    if (state.lmsManager.trainingData?.[key]) return
    dispatch(actions.fetchingTrainingAttempts())
    try {
      const { data: trainingData } = await apiV1.getTrainingAttempts(
        program,
        learners,
      )
      dispatch(
        actions.fetchingTrainingAttemptsSuccess(
          siteId,
          license.id,
          program,
          trainingData,
        ),
      )
    } catch (error) {
      dispatch(actions.fetchingTrainingAttemptsError(error))
    }
  }
}

const fetchTrainingCompletion = siteId => {
  return async (dispatch, getState) => {
    const state = getState()
    if (state.lmsManager.trainingCompletionData?.[siteId]) return
    dispatch(actions.fetchingTrainingCompletion())
    try {
      const { data: completionData } = await apiV2.getTrainingCompletion(siteId)
      dispatch(
        actions.fetchingTrainingCompletionSuccess(siteId, completionData),
      )
    } catch (error) {
      dispatch(actions.fetchingTrainingCompletionError(error))
    }
  }
}

export default {
  fetchTrainingAttempts,
  fetchTrainingCompletion,
}
